"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserInfo = void 0;
var tslib_1 = require("tslib");
var bowser_1 = tslib_1.__importDefault(require("bowser"));
function getBrowserInfo() {
    var _a;
    var browser = bowser_1.default.getParser(window.navigator.userAgent);
    return {
        name: ((_a = browser.getBrowser().name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'Unknown',
        version: browser.getBrowser().version || 'Unknown',
    };
}
exports.getBrowserInfo = getBrowserInfo;
